import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Header/Header.js'
import '@isceco/widget-library2/basic-elements/LanguageSwitcher/LanguageSwitcher.js'
import '@isceco/widget-library2/basic-elements/Link/Link.js'
import '@isceco/widget-library2/basic-elements/ActionMenu/ActionMenu.js'
import ConfigUtil from '../../services/ConfigUtil'
import WebComponent from '../../WebComponent.js'
import BerechtigungUtil from '../../services/BerechtigungUtil'
import Navigation from '../Navigation/Navigation'

export default class Header extends WebComponent {

  constructor() {
    super()
    this.berechtigungUtil = new BerechtigungUtil()
  }

  get translationFile() {
    return './views/Header/i18n.json'
  }

  get css() {
    return css`
      .user-menu {
        display: flex;
        flex-flow: column wrap;
        align-items: end;
      }

      .user-language {
        display: flex;
        align-items: end;
        flex-direction: column;
      }

      #stage-info {
        position: absolute;
        top: 1em;
        left: -2em;
        background-color: yellow;
        transform: rotate(-45deg);
        transform-origin: center;
        text-align: center;
        font-size: 1.25em;
        word-break: normal;
        width: 8em;
        padding: .4em;
      }

      #stage-info[title=EN] {
        background-color: var(--isceco-color-red-500);
      }

      #stage-info[title=IN] {
        background-color: var(--isceco-color-yellow-500);
      }

      #stage-info[title=VP] {
        background-color: var(--isceco-color-green-500);
      }
    `
  }

  connectedCallback() {
    super.connectedCallback()
    this.logoutPage = ''
    this.myAccountPage = ''
    this.stage = ''
    this.reload()
  }

  reload() {
    Promise.resolve(
      new ConfigUtil().retrieveConfiguration()
    ).then(config => {
      this.logoutPage = config.logoutPage
      this.myAccountPage = config.myAccountPage
      this.stage = config.stage
    }).catch(_ => {
    }).finally(() => {
      this.render()
    })
  }

  getTemplate() {
    return html`
      ${this.stage && this.stage !== 'PR' ? html`
        <aside id="stage-info" title="${this.stage}">${this.stage}</aside>
      ` : ''}
      <isceco-header text="${this.i18n.translate('header.text')}">
        <div class="user-language">
          <isceco-language></isceco-language>
          <div class="user-menu">
            <isceco-action-menu id="user-action-menu"
                                .items="${this._getActionMenuItems()}">
              <isceco-link slot="wrapper"
                           text="${this.displayName()}"
                           icon="user circle outline"
              </isceco-link>
            </isceco-action-menu>
          </div>
        </div>
      </isceco-header>
    `
  }

  _getActionMenuItems() {
    const items = [
      {
        icon: 'user',
        text: this.i18n.translate('header.my-account'),
        url: this.myAccountPage,
        target: '_blank'
      }
    ]
    if (this.berechtigungUtil.getUserProfiles().length > 1) {
      this.berechtigungUtil.getUserProfiles().forEach(p => items.push(
        {
          icon: 'id badge',
          text: `${this.i18n.translate('header.profile')}: ${p.name}`,
          callback: _ => this._changeProfile(p)
        }
      ))
    }
    items.push(
      {
        icon: 'id badge',
        text: this.i18n.translate('header.onboarding'),
        url: Navigation.ROUTES.onboarding.url
      },
      {
        icon: 'sign out',
        text: this.i18n.translate('header.logout'),
        variant: 'danger',
        callback: _ => window.keycloak.logout({redirectUri: this.logoutPage})
      }
    )
    return items
  }

  displayName = () => {
    if (!isEmpty(window.keycloak)) {
      const profile = this.berechtigungUtil.getActiveProfile() ? `(${this.berechtigungUtil.getActiveProfile()?.name})` : ''
      return `${window.keycloak.tokenParsed.given_name} ${window.keycloak.tokenParsed.family_name} ${profile}`
    } else {
      return ''
    }
  }

  _changeProfile = profile => {
    this.berechtigungUtil.setActiveProfile(profile)
    location.reload()
  }
}

customElements.define('eko-frontend-header', Header)
